import { isPathMatches } from '@terminal/components/app-header/utils/navigation-utils';
import { useChatInputHandlers } from '@terminal/components/chat/chat-input/chat-quick-analysis/useChatInputHandlers';
import { useChatInputNavigate } from '@terminal/hooks/use-chat-input-navigate/useChatInputNavigate';
import { TrackingMetadata } from '@terminal/services/tracking/posthog/constants';
import { useChat } from '@terminal/views/alfred/quick-analysis/use-chat/useChat';
import { useEffect, useRef } from 'react';

import { ChatInputComposer } from '../chat-input-composer/ChatInputComposer';
import { ChatInputConfig } from '../types';

export interface ChatInputProps {
  submitCallback?: (message?: string) => void;
  config?: ChatInputConfig;
  trackingMetadata?: TrackingMetadata;
}

export const ChatQuickAnalysis = ({
  submitCallback,
  config,
  trackingMetadata,
}: ChatInputProps) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const chatInputNavigation = useChatInputNavigate();

  const { isMessagePending, messages } = useChat(state => ({
    isMessagePending: state.isMessagePending,
    messages: state.messages,
  }));

  const isTargetPage = isPathMatches(['alfred', 'chart']);
  const isLoading = isTargetPage && isMessagePending;

  const handlers = useChatInputHandlers({
    config,
    submitCallback,
    isLoading,
    trackingMetadata,
  });

  useEffect(() => {
    const lastMessage = messages.at(-1);
    chatInputNavigation(lastMessage);
  }, [messages, chatInputNavigation]);

  return (
    <ChatInputComposer
      ref={inputRef}
      handlers={handlers}
      config={{
        ...config,
        isLoading,
      }}
      trackingMetadata={trackingMetadata}
      promptRefinementContext={{
        messageId: messages.at(-1)?.id,
      }}
    />
  );
};
